function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import ReactPlayer from "react-player";
import VisibilitySensor from "react-visibility-sensor";
import { generateCloudinaryImageUrl, generateCloudinaryVideoUrl, generateCloudinaryVideoThumbnail, generateCloudinaryVideoThumbnailFromFullUrl } from "services/community/cloudinary-service";
import classnames from "classnames";
import { StyledVideoComponent } from "./video-component.scss";
import { isCloudinaryUrl } from "/services/community/cloudinary-service";
const VideoComponent = (props)=>{
    const [isVisible, setVisible] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [hadFocusWithKeyboardEvent, setHadFocusWithKeyboardEvent] = useState(false);
    /* Video configuration */ const shouldPlayVideo = ()=>{
        const { playWhenVisible, autoPlay, disableAutoplay, hideControls } = props;
        if (!hideControls && disableAutoplay) {
            return false;
        }
        if (!playWhenVisible) {
            return autoPlay;
        }
        return isVisible;
    };
    const getUrl = ()=>{
        let url;
        if (props.singleUrl) {
            url = props.singleUrl;
        } else {
            // Only set urls on init so player is not refreshed on every update
            const formats = props.formats.filter((urlFormat)=>urlFormat); // clean undefined
            if (formats.length > 0) {
                if (isCloudinaryUrl(formats[0])) {
                    url = formats[0];
                } else {
                    url = generateCloudinaryVideoUrl(formats[0], {
                        assetQuality: props.assetQuality
                    });
                }
            } else {
                url = [];
            }
        }
        return url;
    };
    const getPoster = ()=>{
        const { poster } = props;
        let fixedPosterUrl;
        if (poster) {
            fixedPosterUrl = generateCloudinaryImageUrl(poster);
        } else {
            const { formats } = props;
            const videoUrl = formats[0];
            if (videoUrl) {
                if (isCloudinaryUrl(videoUrl)) {
                    fixedPosterUrl = generateCloudinaryVideoThumbnailFromFullUrl(videoUrl);
                } else {
                    fixedPosterUrl = generateCloudinaryVideoThumbnail(videoUrl);
                }
            }
        }
        return fixedPosterUrl;
    };
    const getConfig = (poster)=>{
        const { config, ariaLabel } = props;
        const newConfig = _object_spread({}, config);
        newConfig.file = config.file || {};
        newConfig.file.attributes = _object_spread_props(_object_spread({}, newConfig.file.attributes), {
            poster,
            "aria-label": ariaLabel
        });
        return newConfig;
    };
    /* Events */ const onClick = ()=>{
        props.onClick && props.onClick();
    };
    const onMouseEnter = ()=>{
        setHovered(true);
    };
    const onMouseLeave = ()=>{
        setHovered(false);
    };
    const onFocus = ()=>{
        if (!hovered) {
            setHadFocusWithKeyboardEvent(true);
        }
    };
    const onVisibilityChange = (isVisible)=>{
        setTimeout(()=>setVisible(isVisible), 200);
    };
    const showControls = ()=>{
        if (hideControls === undefined) {
            return !loop;
        }
        if (hideControls) {
            return false;
        }
        return hovered || hadFocusWithKeyboardEvent;
    };
    const { style, playWhenVisible, loop, muted, volume, playsInline, hideControls } = props;
    const { singleUrl, formats, assetQuality, poster, config, ariaLabel, className, videoPlayerRef, onStart, onEnded, onDuration, hideBlackBars } = props;
    const memoizedUrl = useMemo(()=>getUrl(), [
        singleUrl,
        formats,
        assetQuality
    ]);
    const memoizedPoster = useMemo(()=>getPoster(), [
        poster,
        formats
    ]);
    const memoizedConfig = useMemo(()=>getConfig(memoizedPoster), [
        memoizedPoster,
        config,
        ariaLabel
    ]);
    const tabIndex = hideControls ? -1 : 0;
    const getStyle = ()=>{
        const { height } = props;
        return height ? {
            height
        } : {};
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: 100,
            top: 100
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: playWhenVisible,
        scrollCheck: playWhenVisible,
        children: /*#__PURE__*/ _jsx(StyledVideoComponent, {
            className: classnames("video-component", {
                "hide-black-bars": hideBlackBars
            }),
            style: getStyle(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ _jsx(ReactPlayer, {
                ref: videoPlayerRef,
                className: classnames("react-player-video-component", className),
                url: [
                    memoizedUrl
                ],
                style: style,
                playsinline: playsInline,
                playing: shouldPlayVideo(),
                config: memoizedConfig,
                muted: muted,
                volume: volume,
                loop: loop,
                controls: showControls(),
                width: "100%",
                height: "100%",
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration
            })
        })
    });
};
VideoComponent.defaultProps = {
    formats: [],
    autoPlay: true,
    playWhenVisible: true,
    muted: true,
    volume: 0,
    config: {},
    playsInline: true,
    ariaLabel: null,
    singleUrl: null,
    videoPlayerRef: null
};
export default VideoComponent;
